module.exports = __webpack_public_path__ + "static/img/scfk.99b8253d.png";